import { render, staticRenderFns } from "./OrdersByCategory.vue?vue&type=template&id=d543bf5e&scoped=true&"
import script from "./OrdersByCategory.vue?vue&type=script&lang=js&"
export * from "./OrdersByCategory.vue?vue&type=script&lang=js&"
import style0 from "./OrdersByCategory.vue?vue&type=style&index=0&id=d543bf5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d543bf5e",
  null
  
)

export default component.exports